import { type ZodType, z } from 'zod';
import { DEFAULT_PROFILE_DETAILS } from '@bo-constants/member/members';
import type { MemberAccountInformation } from '@library/types/members';
import { isValidDateString } from '@library/component-utils/dateTime';

export const memberAccountInfoSchema: ZodType<MemberAccountInformation> =
  z.object({
    address: z.string().min(1, 'Address is required'),
    city: z.string().min(1, 'City is required'),
    dateOfBirth: z
      .string()
      .min(1, 'Date of birth is required')
      .refine((value) => !value || isValidDateString(value), {
        message: 'Please enter a valid date in MM-DD-YYYY format'
      }),
    email: z
      .string()
      .min(1, 'Email is required')
      .email('Please enter a valid email address'),
    firstName: z.string().min(1, 'First name is required'),
    inviteCode: z.string().optional(),
    lastName: z.string().min(1, 'Last name is required'),
    phoneNumber: z
      .string()
      .optional()
      .refine(
        (val) =>
          !val || /^\+?1?\s*\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/.test(val),
        {
          message: 'Please enter a valid 11-digit phone number'
        }
      ),
    postalCode: z.string().min(1, 'Zip code is required'),
    state: z.string().min(1, 'State is required'),
    username: z
      .string()
      .optional()
      .refine(
        (val) =>
          !val ||
          val === DEFAULT_PROFILE_DETAILS.username ||
          /^[a-zA-Z0-9._]{3,15}$/.test(val),
        {
          message:
            'Must be 3-15 alphanumeric characters, with optional underscores and periods, and no spaces or special characters'
        }
      ),
    verified: z.boolean().optional()
  });
